<template lang="html">
  <el-row>
    <el-col >
      <el-row class="bg-eee pd-tb10 pd-lr10 border-radio10">
        <div class="title" v-html='qdata.content'></div>
        <div class="option">
          <ul>
            <li
              :class="[qdata.answer.split(',').includes((index).toString())?'activer':'']"
              :key="index" v-for="(option,index) in qdata.options">
              {{index | indexTransform}}.
              <span v-html="option"></span>
            </li>
          </ul>
        </div>
        <div class="awser">
          答案： <span v-for="awser in qdata.answer.split(',')">{{awser | indexTransform}}</span>
        </div>
        <div class="analysis">
          解析：{{qdata.analysis}}
        </div>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'SmartSingle',
  props:['qdata'],
  created(){
    console.log(this.qdata);
  },
  filters: {
    indexTransform: function (value) {
      value = Number(value)
      return String.fromCharCode(65 + parseInt(value));
    }
  },
}
</script>

<style lang="scss" scoped>
.title{
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.awser,.analysis{
  font-size: 14px;
  padding-bottom: 10px;
  padding-left: 5px;
  color: #666;
}
.option{
  font-size: 14px;
  margin: 15px 5px;
  li{
    padding: 10px 0;
     span{
      line-height: 16px;
    }
  }
  li.activer{
    color: #409EFF;
  }
}
.bg-eee{
      background: #eee;
}
.border-radio10 {
    border-radius: 10px;
}
</style>
